module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/owner-layout/owner-layout.component.scss
// module id = ./src/app/layouts/owner-layout/owner-layout.component.scss
// module chunks = main